var _path, _path2, _g, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPopoverCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 126,
    viewBox: "0 0 126 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63 126C97.7939 126 126 97.7939 126 63C126 28.2061 97.7939 0 63 0C28.2061 0 0 28.2061 0 63C0 97.7939 28.2061 126 63 126ZM62.9988 109.964C88.9361 109.964 109.962 88.9376 109.962 63.0003C109.962 37.063 88.9361 16.0366 62.9988 16.0366C37.0615 16.0366 16.0352 37.063 16.0352 63.0003C16.0352 88.9376 37.0615 109.964 62.9988 109.964Z",
    fill: "#141725"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3542_7668",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 126,
    height: 126
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63 126C97.7939 126 126 97.7939 126 63C126 28.2061 97.7939 0 63 0C28.2061 0 0 28.2061 0 63C0 97.7939 28.2061 126 63 126ZM62.9988 109.964C88.9361 109.964 109.962 88.9376 109.962 63.0003C109.962 37.063 88.9361 16.0366 62.9988 16.0366C37.0615 16.0366 16.0352 37.063 16.0352 63.0003C16.0352 88.9376 37.0615 109.964 62.9988 109.964Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3542_7668)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6787 70V55.9H48.5987L56.1787 65.74V55.9H58.5587V70H56.6587L49.0587 60.12V70H46.6787ZM61.5796 71.42L59.6996 70.86L64.8796 54.8L66.7596 55.36L61.5796 71.42ZM65.9985 70L72.3785 55.9H74.4785L80.8585 70H78.2585L76.8585 66.74H69.9785L68.5985 70H65.9985ZM73.3985 58.68L70.8585 64.7H75.9785L73.4385 58.68H73.3985Z",
    fill: "#141725"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopoverCircle);
export default __webpack_public_path__ + "static/media/popover_circle.988cb4dac44503f1972cc3e788c568dd.svg";
export { ForwardRef as ReactComponent };